import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:pb-5 home__info pl-4 sm:pl-0"
}
const _hoisted_2 = { class: "border p-4 flex items-center gap-4 home__info__card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.24 5.58H18.84L15.46 2.2C15.19 1.93 14.75 1.93 14.47 2.2C14.2 2.47 14.2 2.91 14.47 3.19L16.86 5.58H7.14L9.53 3.19C9.8 2.92 9.8 2.48 9.53 2.2C9.26 1.93 8.82 1.93 8.54 2.2L5.17 5.58H4.77C3.87 5.58 2 5.58 2 8.14C2 9.11 2.2 9.75 2.62 10.17C2.86 10.42 3.15 10.55 3.46 10.62C3.75 10.69 4.06 10.7 4.36 10.7H19.64C19.95 10.7 20.24 10.68 20.52 10.62C21.36 10.42 22 9.82 22 8.14C22 5.58 20.13 5.58 19.24 5.58Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.0502 12H4.87016C4.25016 12 3.78016 12.55 3.88016 13.16L4.72016 18.3C5.00015 20.02 5.75015 22 9.08015 22H14.6902C18.0602 22 18.6602 20.31 19.0202 18.42L20.0302 13.19C20.1502 12.57 19.6802 12 19.0502 12ZM12.0002 19.5C9.66016 19.5 7.75016 17.59 7.75016 15.25C7.75016 14.84 8.09016 14.5 8.50015 14.5C8.91015 14.5 9.25015 14.84 9.25015 15.25C9.25015 16.77 10.4802 18 12.0002 18C13.5202 18 14.7502 16.77 14.7502 15.25C14.7502 14.84 15.0902 14.5 15.5002 14.5C15.9102 14.5 16.2502 14.84 16.2502 15.25C16.2502 17.59 14.3402 19.5 12.0002 19.5Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-sm md:text-md" }, "Pedido mínimo", -1)
const _hoisted_5 = {
  key: 0,
  class: "font-bold text-xs md:text-sm text-success"
}
const _hoisted_6 = {
  key: 1,
  class: "sf-skeleton w-15 h-4 animate-pulse"
}
const _hoisted_7 = { class: "border p-4 flex items-center gap-4 home__info__card" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-clock",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" })
], -1)
const _hoisted_9 = { class: "font-medium text-sm md:text-md" }
const _hoisted_10 = {
  key: 0,
  class: "sf-skeleton w-15 h-4 animate-pulse"
}
const _hoisted_11 = {
  key: 1,
  class: "text-xs text-success font-bold md:text-sm pr-10"
}
const _hoisted_12 = {
  key: 2,
  class: "text-xs md:text-sm text-red-500 font-medium pr-10"
}
const _hoisted_13 = { class: "border p-4 flex items-center gap-4 home__info__card" }
const _hoisted_14 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.65rem","height":"1.65rem"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-sm md:text-md" }, "Whatsapp", -1)
const _hoisted_18 = { class: "font-bold text-xs md:text-sm text-success" }

import { computed } from 'vue'
import { Pagination, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { restaurant } from '@/global/state/GlobalState'
import { InfoSection } from '@/global/state/StorefrontState'
import { formatBRL } from '../storefrontUtils'

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'InfoSection',
  props: {
    section: {}
  },
  setup(__props: any) {

const props = __props

const modules = [Pagination, FreeMode]
const daysFormat: Record<number, string> = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado'
}

const todaySchedule = computed(() => restaurant.value.schedules?.find((s: any) => s.day == new Date().getDay()))

const hasAnyCard = computed(() => {
  const s = props.section.settings
  return s.showMinimumOrder || s.showHours || (s.showWhatsapp && !!restaurant.value.restaurantConfig?.whatsapp)
})

return (_ctx: any,_cache: any) => {
  return (hasAnyCard.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Swiper), {
          "slides-per-view": 4.4,
          "space-between": 20,
          pagination: true,
          modules: modules,
          breakpoints: { 0: { slidesPerView: 1.4, spaceBetween: 10 }, 450: { slidesPerView: 1.6, spaceBetween: 10 }, 600: { slidesPerView: 1.8 }, 900: { slidesPerView: 3, spaceBetween: 10 }, 1100: { slidesPerView: 4, spaceBetween: 20 } },
          class: "pb-10"
        }, {
          default: _withCtx(() => [
            (_ctx.section.settings.showMinimumOrder)
              ? (_openBlock(), _createBlock(_unref(SwiperSlide), { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("div", null, [
                        _hoisted_4,
                        (_unref(restaurant).restaurantConfig?.minimumOrderAmount != null)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_5, _toDisplayString(_unref(formatBRL)(_unref(restaurant).restaurantConfig?.minimumOrderAmount)), 1))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_6))
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.section.settings.showHours)
              ? (_openBlock(), _createBlock(_unref(SwiperSlide), { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(daysFormat[new Date().getDay()]), 1),
                        (!_unref(restaurant).id)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_10))
                          : _createCommentVNode("", true),
                        (todaySchedule.value)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_11, _toDisplayString(todaySchedule.value.openingTime.slice(0, 5)) + "h às " + _toDisplayString(todaySchedule.value.closingTime.slice(0, 5)) + "h", 1))
                          : _createCommentVNode("", true),
                        (!todaySchedule.value && _unref(restaurant).id)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Fechado"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.section.settings.showWhatsapp && _unref(restaurant).restaurantConfig?.whatsapp)
              ? (_openBlock(), _createBlock(_unref(SwiperSlide), { key: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16)),
                      _createElementVNode("div", null, [
                        _hoisted_17,
                        _createElementVNode("h6", _hoisted_18, _toDisplayString(_unref(restaurant).restaurantConfig?.whatsapp), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})